import React, { useState } from 'react';
import variables from '../../assets/variables.json';
import { version as appVersion } from '../../package.json';

const menuItems = [
  'NOUVEAUTES',
  'HOMMES',
  'FEMMES',
  'ENFANTS',
  'MARQUES',
  'SOLDES',
  // 'ABONNEMENT CLUB SELECT',
  // 'CARTE CADEAU',
  // 'CORPORATIF',
];

function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M16 16l4.5 4.5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function BagIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 9h10l-1 11H8L7 9z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M9 9a3 3 0 0 1 6 0" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="8" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M5.5 19.5a6.5 6.5 0 0 1 13 0" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const topBarMessage = variables.find((item) => item.label === 'top-bar')?.text || '';
  const versionMessage = appVersion || '';
  const goTo = (path) => {
    window.location.href = path;
  };

  return (
    <>
      <div className="topbar">
        <div className="topbar__message">
          {topBarMessage} v{versionMessage}
        </div>
        <div className="topbar__actions">
          <button className="utility-action" type="button">
            <SearchIcon />
            <span>Recherche</span>
          </button>
          <button className="utility-icon" type="button" aria-label="Panier">
            <BagIcon />
          </button>
          <button className="utility-action" type="button" onClick={() => goTo('/login')}>
            <UserIcon />
            <span>Connexion</span>
          </button>
          <span className="topbar__divider" aria-hidden="true" />
          <button className="utility-link" type="button">
            EN(CAD)
          </button>
        </div>
      </div>

      <header className="navbar">
        <div className="navbar__mobile-bar">
          <button
            className={`navbar__hamburger${menuOpen ? ' is-open' : ''}`}
            type="button"
            aria-label="Menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </button>

          <div className="navbar__mobile-actions">
            <button className="utility-icon" type="button" aria-label="Recherche">
              <SearchIcon />
            </button>
            <button className="utility-icon" type="button" aria-label="Panier">
              <BagIcon />
            </button>
            <button
              className="utility-icon"
              type="button"
              aria-label="Connexion"
              onClick={() => goTo('/login')}
            >
              <UserIcon />
            </button>
            <span className="navbar__mobile-divider" aria-hidden="true" />
            <button className="utility-link utility-link--mobile" type="button">
              EN(CAD)
            </button>
          </div>
        </div>

        <div className={`navbar__mobile-menu${menuOpen ? ' is-open' : ''}`}>
          {menuItems.map((item) => (
            <button
              key={item}
              className="navbar__mobile-menu-item"
              type="button"
              onClick={() => setMenuOpen(false)}
            >
              {item}
            </button>
          ))}
        </div>

        <button className="navbar__logo" type="button" aria-label="Rive Moderne" onClick={() => goTo('/')}>
          <span className="navbar__logo-top">Rive</span>
          <span className="navbar__logo-bottom">Moderne</span>
        </button>

        <nav className="navbar__menu" aria-label="Desktop navigation">
          {menuItems.map((item) => (
            <button
              key={item}
              className={`nav-item${item === 'SOLDES' ? ' nav-item--sale' : ''}`}
              type="button"
            >
              {item}
            </button>
          ))}
        </nav>
      </header>
    </>
  );
}
